var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mt-4 box-users" }, [
    _c("div", { staticClass: "col-md-6 border-right mb-3" }, [
      _c("h5", [_vm._v("Usuarios de la empresa")]),
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-end" },
        [
          _c("b-form-input", {
            staticClass: "d-inline-block mr-1",
            attrs: { placeholder: "Filtrar...", "data-cy": "search-user" },
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "col-md-6 border-right mb-3" }, [
      _c("h5", [_vm._v("Usuarios en el grupo")]),
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-end" },
        [
          _c("b-form-input", {
            staticClass: "d-inline-block mr-1",
            attrs: {
              placeholder: "Filtrar...",
              "data-cy": "search-user-group"
            },
            model: {
              value: _vm.searchUsers,
              callback: function($$v) {
                _vm.searchUsers = $$v
              },
              expression: "searchUsers"
            }
          })
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "col-md-6 border-right" },
      [
        _c(
          "vs-list",
          { staticClass: "box-users", attrs: { "data-cy": "company-users" } },
          _vm._l(_vm.filteredUsers, function(user) {
            return _c(
              "div",
              { key: user.id, attrs: { "data-cy": "user" } },
              [
                _c(
                  "vs-list-item",
                  {
                    class: { exists: _vm.isUserInGroup(user) },
                    attrs: { title: user.nombre, subtitle: user.correo }
                  },
                  [
                    !_vm.isUserInGroup(user)
                      ? _c(
                          "vs-button",
                          {
                            attrs: {
                              color: "warning",
                              size: "small",
                              type: "border",
                              "data-cy": "add-user"
                            },
                            on: {
                              click: function($event) {
                                return _vm.addUser(user)
                              }
                            }
                          },
                          [_vm._v(" Agregar ")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          }),
          0
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c(
          "vs-list",
          { staticClass: "box-users", attrs: { "data-cy": "group-users" } },
          _vm._l(_vm.filteredUsersOnGroup, function(user) {
            return _c(
              "div",
              { key: user.id, attrs: { "data-cy": "user" } },
              [
                _c(
                  "vs-list-item",
                  { attrs: { title: user.nombre, subtitle: user.correo } },
                  [
                    user.esLider === "Y"
                      ? _c(
                          "vs-chip",
                          { attrs: { color: "warning" } },
                          [
                            _c("vs-avatar", { attrs: { icon: "flag" } }),
                            _vm._v(" lider ")
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("vs-button", {
                      attrs: {
                        color: "danger",
                        size: "small",
                        type: "border",
                        icon: "highlight_off",
                        "data-cy": "remove-user"
                      },
                      on: {
                        click: function($event) {
                          return _vm.removeUser(user)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          }),
          0
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }